export const cols = [{
	prop: 'code',
	label: '商品编号',
	width: '120',
	align: 'center',
	show: true
}, {
	prop: 'sourceflag',
	label: '商品来源',
	width: '110',
	align: 'center',
	show: true
}, {
	prop: 'bcName',
	label: '店铺级大类',
	width: '180',
	align: 'center',
	show: true
}, {
	prop: 'scName',
	label: '店铺级小类',
	width: '180',
	align: 'center',
	show: true
}, {
	prop: 'highQuality',
	label: '精选推荐',
	width: '180',
	align: 'center',
	show: false
}]
// {
// 	prop: 'goodsName',
// 	label: '商品名称',
// 	width: '180',
// 	align: 'center',
// 	show: true
// }
